import {
  IPresetOption,
  IPresetTrainingSpec,
} from '../interfaces/training/i-preset-training-spec';

// aka: bs origin
export type PrecursorSource =
  | 'hawkeye'
  | 'manual'
  | 'msbs'
  | 'rapsodo'
  | 'trackman'
  | 'vision';

export enum TrackingDevice {
  Hawkeye = 'Hawkeye',
  RapsodoV3PRO = 'Rapsodo V3 PRO',
  TrackmanB1 = 'Trackman B1',
  TrajektVision = 'Trajekt Vision',
}

export const FF_NAME_CONTINUOUS_TRAINING = 'continuous-training';
export const FF_NAME_ON_DEMAND_MODE = 'on-demand-mode';

export const CONTINUOUS_TRAINING_SUPPORTED_DEVICES = [
  // TrackingDevice.Hawkeye,
  // TrackingDevice.RapsodoV3PRO,
  // TrackingDevice.TrackmanB1,
  TrackingDevice.TrajektVision,
];

export const PrecursorTrackingDeviceMap = {
  hawkeye: TrackingDevice.Hawkeye,
  manual: TrackingDevice.Hawkeye,
  msbs: TrackingDevice.RapsodoV3PRO,
  rapsodo: TrackingDevice.RapsodoV3PRO,
  trackman: TrackingDevice.TrackmanB1,
  vision: TrackingDevice.TrajektVision,
};

export enum PresetTrainingMode {
  Quick = 'Quick',
  Precision = 'Precision',
  Custom = 'Custom',
  Balanced = 'Balanced',
}

export const PRECISE_PT_MODES = [
  PresetTrainingMode.Custom,
  PresetTrainingMode.Precision,
];

export const MAX_ADJUSTMENTS = 10;

export const DEFAULT_PRESET_TRAINING_SPEC: IPresetTrainingSpec = {
  minutesPerPitch: 1,
  minSamples: 2,
  maxSamples: 3,
  maxAdjustments: 3,
  deltaSpeedMPH: 2,
  deltaSpinsRPM: 400,
  deltaBreaksInches: 4,
  smartSampling: false,
};

export const DELTA_BREAKS_INCHES_FOR_3_6OZ = 5;

export const PRESET_TRAINING_OPTIONS: IPresetOption[] = [
  {
    // * Quick only ever compares the number of shots vs machine training threshold, so these values are irrelevant
    mode: PresetTrainingMode.Quick,
    spec: {
      minutesPerPitch: 1,
      minSamples: 0,
      maxSamples: 0,
      maxAdjustments: 0,
      deltaSpeedMPH: 0,
      deltaBreaksInches: 0,
      deltaSpinsRPM: 0,
      smartSampling: false,
    },
  },
  {
    mode: PresetTrainingMode.Precision,
    spec: {
      minutesPerPitch: 2,
      minSamples: 2,
      maxSamples: 8,
      maxAdjustments: 4,
      deltaSpeedMPH: 1.4,
      // * needs to be overwritten depending on the ball type (e.g. 5 for 3.6oz)
      deltaBreaksInches: 4,
      deltaSpinsRPM: 300,
      smartSampling: true,
    },
    canPrecisionTrain: true,
  },
  {
    mode: PresetTrainingMode.Custom,
    spec: {
      minutesPerPitch: undefined,
      minSamples: 2,
      maxSamples: 8,
      maxAdjustments: 4,
      deltaSpeedMPH: 1.4,
      // * needs to be overwritten depending on the ball type (e.g. 5 for 3.6oz)
      deltaBreaksInches: 4,
      deltaSpinsRPM: 300,
      smartSampling: true,
    },
    canPrecisionTrain: true,
    showSmartSamplingToggle: true,
    showControls: true,
  },
];

export const MAX_INCH_DIFF = 10;

export const MIN_PITCH_MPH = 40.26;
export const MAX_PITCH_MPH = 130.0;

export const MAX_PITCH_BREAK_FT = 4;
export const MAX_VX_DELTA_MPH = 4.5;

export const MIN_TRAINING_SHOTS = 3;
export const MAX_TRAINING_SHOTS = 10;

export const VLOW_LIKELIHOOD = 0.02;
export const LOW_LIKELIHOOD = 0.3;
export const TRAINING_DELAY_SEC = 20;

export enum TrainingOutcome {
  PT_GiveUp = 'PT Give Up',
  PT_Complete = 'PT Complete',
  PT_Failure = 'PT Failure',
  QT_GiveUp = 'QT Give Up',
  QT_Complete = 'QT Complete',
}

export enum TrainingAdjustment {
  // nothing changed
  None = 'none',
  // aimingTraj updated
  Aiming = 'aiming',
  // ms updated
  Ms = 'ms',
  // contShotErrors pruned
  Prune = 'prune',
  // invalidate shots in conShotErrors
  Invalidate = 'invalidate',
}
